import { connect } from 'react-redux';
import Dashboard from 'components/dashboard/Dashboard';

const mapStateToProps = (state) => {
  return {
    data: state.dashboard,
    meta: state.meta.dashboard,
  }
}

const DashboardContainer = connect(
  mapStateToProps,
  null
)(Dashboard)

export default DashboardContainer;
